//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiClientBase } from './ApiClientBase';

export class SummeetClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getConfig(): Promise<void> {
        let url_ = this.baseUrl + "/config/api.js";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfig(_response));
        });
    }

    protected processGetConfig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getLogConfig(): Promise<string> {
        let url_ = this.baseUrl + "/config/log-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLogConfig(_response));
        });
    }

    protected processGetLogConfig(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param sampleRate (optional) 
     * @param audioCodec (optional) 
     * @param audioFormat (optional) 
     * @return Success
     */
    streamMediaForAsr(meetingId: string, speakerFileName: string, sampleRate: number | undefined, audioCodec: string | undefined, audioFormat: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/speakers/{speakerFileName}/asr?";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (speakerFileName === undefined || speakerFileName === null)
            throw new Error("The parameter 'speakerFileName' must be defined.");
        url_ = url_.replace("{speakerFileName}", encodeURIComponent("" + speakerFileName));
        if (sampleRate === null)
            throw new Error("The parameter 'sampleRate' cannot be null.");
        else if (sampleRate !== undefined)
            url_ += "sampleRate=" + encodeURIComponent("" + sampleRate) + "&";
        if (audioCodec === null)
            throw new Error("The parameter 'audioCodec' cannot be null.");
        else if (audioCodec !== undefined)
            url_ += "audioCodec=" + encodeURIComponent("" + audioCodec) + "&";
        if (audioFormat === null)
            throw new Error("The parameter 'audioFormat' cannot be null.");
        else if (audioFormat !== undefined)
            url_ += "audioFormat=" + encodeURIComponent("" + audioFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStreamMediaForAsr(_response));
        });
    }

    protected processStreamMediaForAsr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    streamMediaRaw(meetingId: string, speakerFileName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/speakers/{speakerFileName}/raw";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (speakerFileName === undefined || speakerFileName === null)
            throw new Error("The parameter 'speakerFileName' must be defined.");
        url_ = url_.replace("{speakerFileName}", encodeURIComponent("" + speakerFileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStreamMediaRaw(_response));
        });
    }

    protected processStreamMediaRaw(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    streamAudio(meetingId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/audio";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStreamAudio(_response));
        });
    }

    protected processStreamAudio(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    streamAudioRaw(meetingId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/audio/raw";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStreamAudioRaw(_response));
        });
    }

    protected processStreamAudioRaw(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingRawAudioName(meetingId: string): Promise<string[]> {
        let url_ = this.baseUrl + "/media/{meetingId}/audio/raw/name";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingRawAudioName(_response));
        });
    }

    protected processGetMeetingRawAudioName(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    hasAudioRaw(meetingId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/media/{meetingId}/audio/raw/exists";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasAudioRaw(_response));
        });
    }

    protected processHasAudioRaw(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    streamVideo(meetingId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/video";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStreamVideo(_response));
        });
    }

    protected processStreamVideo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param width (optional) 
     * @param height (optional) 
     * @param color (optional) 
     * @return Success
     */
    getWaveFormPng(meetingId: string, speakerFileName: string, width: number | undefined, height: number | undefined, color: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/speakers/{speakerFileName}/waveform?";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (speakerFileName === undefined || speakerFileName === null)
            throw new Error("The parameter 'speakerFileName' must be defined.");
        url_ = url_.replace("{speakerFileName}", encodeURIComponent("" + speakerFileName));
        if (width === null)
            throw new Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (color === null)
            throw new Error("The parameter 'color' cannot be null.");
        else if (color !== undefined)
            url_ += "color=" + encodeURIComponent("" + color) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWaveFormPng(_response));
        });
    }

    protected processGetWaveFormPng(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWaveSpeakerName(meetingId: string, speakerFileName: string): Promise<ParticipantInfo> {
        let url_ = this.baseUrl + "/media/{meetingId}/speakers/{speakerFileName}/participant";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (speakerFileName === undefined || speakerFileName === null)
            throw new Error("The parameter 'speakerFileName' must be defined.");
        url_ = url_.replace("{speakerFileName}", encodeURIComponent("" + speakerFileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWaveSpeakerName(_response));
        });
    }

    protected processGetWaveSpeakerName(response: Response): Promise<ParticipantInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantInfo>(null as any);
    }

    /**
     * @return Success
     */
    getUserFiles(meetingId: string): Promise<FileShortInfo[]> {
        let url_ = this.baseUrl + "/media/{meetingId}/userFiles";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserFiles(_response));
        });
    }

    protected processGetUserFiles(response: Response): Promise<FileShortInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileShortInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileShortInfo[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @return Success
     */
    uploadUserFile(meetingId: string, files: FileParameter[] | undefined): Promise<FileShortInfo[]> {
        let url_ = this.baseUrl + "/media/{meetingId}/userFiles";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadUserFile(_response));
        });
    }

    protected processUploadUserFile(response: Response): Promise<FileShortInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileShortInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileShortInfo[]>(null as any);
    }

    /**
     * @return Success
     */
    downloadUserFile(meetingId: string, fileName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/{meetingId}/userFiles/{fileName}";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadUserFile(_response));
        });
    }

    protected processDownloadUserFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteUserFile(meetingId: string, fileName: string): Promise<FileShortInfo[]> {
        let url_ = this.baseUrl + "/media/{meetingId}/userFiles/{fileName}";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteUserFile(_response));
        });
    }

    protected processDeleteUserFile(response: Response): Promise<FileShortInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileShortInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileShortInfo[]>(null as any);
    }

    /**
     * @return Success
     */
    getRecorderPlan(recorderId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/media/recorder/{recorderId}/plan";
        if (recorderId === undefined || recorderId === null)
            throw new Error("The parameter 'recorderId' must be defined.");
        url_ = url_.replace("{recorderId}", encodeURIComponent("" + recorderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRecorderPlan(_response));
        });
    }

    protected processGetRecorderPlan(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getById(id: string): Promise<Meeting> {
        let url_ = this.baseUrl + "/meetings/{id}/fullInfo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<Meeting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Meeting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Meeting>(null as any);
    }

    /**
     * @return Success
     */
    getSpeakersFiles(meetingId: string): Promise<SpeakerFileInfo[]> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/speakers";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSpeakersFiles(_response));
        });
    }

    protected processGetSpeakersFiles(response: Response): Promise<SpeakerFileInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpeakerFileInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpeakerFileInfo[]>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingInfo(meetingId: string): Promise<MeetingInfo> {
        let url_ = this.baseUrl + "/meetings/{meetingId}";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingInfo(_response));
        });
    }

    protected processGetMeetingInfo(response: Response): Promise<MeetingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingInfo>(null as any);
    }

    /**
     * @return Success
     */
    deleteMeeting(meetingId: string): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMeeting(_response));
        });
    }

    protected processDeleteMeeting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param loaderName (optional) 
     * @param body (optional) 
     * @return Success
     */
    findMeetingsByRecordingId(loaderName: string | undefined, body: string[] | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/meetings/_findByRecordingId?";
        if (loaderName === null)
            throw new Error("The parameter 'loaderName' cannot be null.");
        else if (loaderName !== undefined)
            url_ += "loaderName=" + encodeURIComponent("" + loaderName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFindMeetingsByRecordingId(_response));
        });
    }

    protected processFindMeetingsByRecordingId(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getParticipantAvatarByEmail(email: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/meetings/participant/byMail/{email}/avatar";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParticipantAvatarByEmail(_response));
        });
    }

    protected processGetParticipantAvatarByEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingRecordingInfo(meetingId: string): Promise<MeetingRecordingSettings> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/recSettingsInfo";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingRecordingInfo(_response));
        });
    }

    protected processGetMeetingRecordingInfo(response: Response): Promise<MeetingRecordingSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingRecordingSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingRecordingSettings>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editMeetingRecordingInfo(meetingId: string, body: MeetingRecordingSettings | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/recSettingsInfo";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditMeetingRecordingInfo(_response));
        });
    }

    protected processEditMeetingRecordingInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param any (optional) 
     * @return Success
     */
    maintenanceFindObsoleteMedia(any: boolean | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/meetings/system/findObsolete4?";
        if (any === null)
            throw new Error("The parameter 'any' cannot be null.");
        else if (any !== undefined)
            url_ += "any=" + encodeURIComponent("" + any) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMaintenanceFindObsoleteMedia(_response));
        });
    }

    protected processMaintenanceFindObsoleteMedia(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllStatuses(): Promise<MeetingStatusInfo[]> {
        let url_ = this.baseUrl + "/meetings/system/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllStatuses(_response));
        });
    }

    protected processGetAllStatuses(response: Response): Promise<MeetingStatusInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeetingStatusInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingStatusInfo[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @param maxResults (optional) 
     * @return Success
     */
    queryParticipant(query: string | undefined, maxResults: number | undefined): Promise<ParticipantInfo[]> {
        let url_ = this.baseUrl + "/meetings/participants?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQueryParticipant(_response));
        });
    }

    protected processQueryParticipant(response: Response): Promise<ParticipantInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantInfo[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: MeetingListRequest | undefined): Promise<MeetingList> {
        let url_ = this.baseUrl + "/meetings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MeetingList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingList>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: AddMeetingRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(meetingId: string, body: AddMeetingRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/update";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInfo(meetingId: string, body: UpdateMeetingInfoRequest | undefined): Promise<UpdateMeetingInfoResponse> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/update-info";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateInfo(_response));
        });
    }

    protected processUpdateInfo(response: Response): Promise<UpdateMeetingInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMeetingInfoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMeetingInfoResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param subject (optional) 
     * @param startUtc (optional) 
     * @param endUtc (optional) 
     * @param location (optional) 
     * @param isPlannedRecording (optional) 
     * @param recordingFile (optional) 
     * @param plannedRecAgentId (optional) 
     * @param plannedRecAgentConfigJson (optional) 
     * @return Success
     */
    createFromUI(id: string | undefined, subject: string | undefined, startUtc: Date | undefined, endUtc: Date | undefined, location: string | undefined, isPlannedRecording: boolean | undefined, recordingFile: FileParameter | undefined, plannedRecAgentId: string | undefined, plannedRecAgentConfigJson: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/add-from-ui";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (subject === null || subject === undefined)
            throw new Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (startUtc === null || startUtc === undefined)
            throw new Error("The parameter 'startUtc' cannot be null.");
        else
            content_.append("StartUtc", startUtc.toJSON());
        if (endUtc === null || endUtc === undefined)
            throw new Error("The parameter 'endUtc' cannot be null.");
        else
            content_.append("EndUtc", endUtc.toJSON());
        if (location === null || location === undefined)
            throw new Error("The parameter 'location' cannot be null.");
        else
            content_.append("Location", location.toString());
        if (isPlannedRecording === null || isPlannedRecording === undefined)
            throw new Error("The parameter 'isPlannedRecording' cannot be null.");
        else
            content_.append("IsPlannedRecording", isPlannedRecording.toString());
        if (recordingFile === null || recordingFile === undefined)
            throw new Error("The parameter 'recordingFile' cannot be null.");
        else
            content_.append("RecordingFile", recordingFile.data, recordingFile.fileName ? recordingFile.fileName : "RecordingFile");
        if (plannedRecAgentId === null || plannedRecAgentId === undefined)
            throw new Error("The parameter 'plannedRecAgentId' cannot be null.");
        else
            content_.append("PlannedRecAgentId", plannedRecAgentId.toString());
        if (plannedRecAgentConfigJson === null || plannedRecAgentConfigJson === undefined)
            throw new Error("The parameter 'plannedRecAgentConfigJson' cannot be null.");
        else
            content_.append("PlannedRecAgentConfigJson", plannedRecAgentConfigJson.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFromUI(_response));
        });
    }

    protected processCreateFromUI(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    maintenancePurgeObsoleteMedia(): Promise<void> {
        let url_ = this.baseUrl + "/meetings/system/purgeObsolete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMaintenancePurgeObsoleteMedia(_response));
        });
    }

    protected processMaintenancePurgeObsoleteMedia(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    duplicate(meetingId: string, body: DuplicateRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/meetings/system/{meetingId}/duplicate";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicate(_response));
        });
    }

    protected processDuplicate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestASR(body: RecordingUpdateInfo | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/system/asr/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestASR(_response));
        });
    }

    protected processRequestASR(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @return Success
     */
    developerSetStatus(meetingId: string, status: MeetingStatuses | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/system/{meetingId}/status?";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeveloperSetStatus(_response));
        });
    }

    protected processDeveloperSetStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param action (optional) 
     * @return Success
     */
    fireStatusAction(meetingId: string, action: MeetingActions | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/statusAction?";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (action === null)
            throw new Error("The parameter 'action' cannot be null.");
        else if (action !== undefined)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFireStatusAction(_response));
        });
    }

    protected processFireStatusAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadRecording(meetingId: string, body: UploadRecordingRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/upload-record";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadRecording(_response));
        });
    }

    protected processUploadRecording(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeAndSendTasks(meetingId: string, body: string[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/complete-and-sendTasks";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompleteAndSendTasks(_response));
        });
    }

    protected processCompleteAndSendTasks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    startMeetingRecording(meetingId: string): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/recrding/start";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartMeetingRecording(_response));
        });
    }

    protected processStartMeetingRecording(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    stopMeetingRecording(meetingId: string): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/recrding/stop";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopMeetingRecording(_response));
        });
    }

    protected processStopMeetingRecording(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    pauseMeetingRecording(meetingId: string): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/recrding/pause";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPauseMeetingRecording(_response));
        });
    }

    protected processPauseMeetingRecording(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    resumeMeetingRecording(meetingId: string): Promise<void> {
        let url_ = this.baseUrl + "/meetings/{meetingId}/recrding/resume";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResumeMeetingRecording(_response));
        });
    }

    protected processResumeMeetingRecording(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRecorderRegistration(recorderId: string, body: RecordingAgentReg | undefined): Promise<void> {
        let url_ = this.baseUrl + "/meetings/recorder/{recorderId}/registration";
        if (recorderId === undefined || recorderId === null)
            throw new Error("The parameter 'recorderId' must be defined.");
        url_ = url_.replace("{recorderId}", encodeURIComponent("" + recorderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRecorderRegistration(_response));
        });
    }

    protected processUpdateRecorderRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    resetRecorderRegistration(recorderId: string): Promise<void> {
        let url_ = this.baseUrl + "/meetings/recorder/{recorderId}/config/_reset";
        if (recorderId === undefined || recorderId === null)
            throw new Error("The parameter 'recorderId' must be defined.");
        url_ = url_.replace("{recorderId}", encodeURIComponent("" + recorderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetRecorderRegistration(_response));
        });
    }

    protected processResetRecorderRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    listRecorderRegistrations(): Promise<RecordingAgentRegInfo> {
        let url_ = this.baseUrl + "/meetings/recorder/_listRegs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListRecorderRegistrations(_response));
        });
    }

    protected processListRecorderRegistrations(response: Response): Promise<RecordingAgentRegInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordingAgentRegInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordingAgentRegInfo>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingMinutes(meetingId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/meetingMinutes";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingMinutes(_response));
        });
    }

    protected processGetMeetingMinutes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDataForML(meetingId: string): Promise<SummaryDataForML> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/summary/_forML";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataForML(_response));
        });
    }

    protected processGetDataForML(response: Response): Promise<SummaryDataForML> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryDataForML.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryDataForML>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSummaries(meetingId: string, body: UpdateSummaryRequest | undefined): Promise<SummaryBlock[]> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/update";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSummaries(_response));
        });
    }

    protected processUpdateSummaries(response: Response): Promise<SummaryBlock[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SummaryBlock.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryBlock[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    makeAuto(meetingId: string, body: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/auto";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMakeAuto(_response));
        });
    }

    protected processMakeAuto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleShowAgenda(meetingId: string, body: ToggleShowAgendaRequest | undefined): Promise<ToggleShowAgendaResponse> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/agenda/toggleShow";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processToggleShowAgenda(_response));
        });
    }

    protected processToggleShowAgenda(response: Response): Promise<ToggleShowAgendaResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ToggleShowAgendaResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToggleShowAgendaResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAgenda(meetingId: string, body: Agenda | undefined): Promise<Agenda> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/agenda";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAgenda(_response));
        });
    }

    protected processUpdateAgenda(response: Response): Promise<Agenda> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agenda.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agenda>(null as any);
    }

    /**
     * @return Success
     */
    sendMeetingMinutesEmail(meetingId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/summaries/{meetingId}/meetingMinutesEmail";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendMeetingMinutesEmail(_response));
        });
    }

    protected processSendMeetingMinutesEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTranscriptReport(meetingId: string, body: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/transcripts/{meetingId}/transcriptReport";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranscriptReport(_response));
        });
    }

    protected processGetTranscriptReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingTranscriptForML(meetingId: string): Promise<MLTranscripts> {
        let url_ = this.baseUrl + "/transcripts/{meetingId}/_forML";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingTranscriptForML(_response));
        });
    }

    protected processGetMeetingTranscriptForML(response: Response): Promise<MLTranscripts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MLTranscripts.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MLTranscripts>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTranscript(meetingId: string, body: AddTranscriptRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transcripts/{meetingId}";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddTranscript(_response));
        });
    }

    protected processAddTranscript(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDiarizedTranscripts(meetingId: string, body: AddDiarizedTranscriptRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transcripts/{meetingId}/diarized";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddDiarizedTranscripts(_response));
        });
    }

    protected processAddDiarizedTranscripts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTranscript(meetingId: string, body: MeetingTranscript_Request | undefined): Promise<TranscriptInfo> {
        let url_ = this.baseUrl + "/transcripts/{meetingId}/update";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranscript(_response));
        });
    }

    protected processUpdateTranscript(response: Response): Promise<TranscriptInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranscriptInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranscriptInfo>(null as any);
    }

    /**
     * @return Success
     */
    getSupportedASRs(): Promise<string[]> {
        let url_ = this.baseUrl + "/transcripts/ASRNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSupportedASRs(_response));
        });
    }

    protected processGetSupportedASRs(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSupportedASRs(body: string[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transcripts/ASRNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSupportedASRs(_response));
        });
    }

    protected processSetSupportedASRs(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userVoice (optional) 
     * @return Success
     */
    setUserVoice(userVoice: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transcripts/voice-embedding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userVoice === null || userVoice === undefined)
            throw new Error("The parameter 'userVoice' cannot be null.");
        else
            content_.append("userVoice", userVoice.data, userVoice.fileName ? userVoice.fileName : "userVoice");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetUserVoice(_response));
        });
    }

    protected processSetUserVoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    completeDiarization(meetingId: string): Promise<void> {
        let url_ = this.baseUrl + "/transcripts/{meetingId}/diarization/complete";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompleteDiarization(_response));
        });
    }

    protected processCompleteDiarization(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AddDiarizedTranscriptRequest implements IAddDiarizedTranscriptRequest {
    speakerFileName?: string | undefined;
    speakerTranscripts?: SpeakerTranscriptJson[] | undefined;

    constructor(data?: IAddDiarizedTranscriptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerFileName = _data["speakerFileName"];
            if (Array.isArray(_data["speakerTranscripts"])) {
                this.speakerTranscripts = [] as any;
                for (let item of _data["speakerTranscripts"])
                    this.speakerTranscripts!.push(SpeakerTranscriptJson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddDiarizedTranscriptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDiarizedTranscriptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerFileName"] = this.speakerFileName;
        if (Array.isArray(this.speakerTranscripts)) {
            data["speakerTranscripts"] = [];
            for (let item of this.speakerTranscripts)
                data["speakerTranscripts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddDiarizedTranscriptRequest {
    speakerFileName?: string | undefined;
    speakerTranscripts?: SpeakerTranscriptJson[] | undefined;
}

export class AddMeetingRequest implements IAddMeetingRequest {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    organizer?: AddParticipantRequest;
    participants?: AddParticipantRequest[] | undefined;
    locations?: Location[] | undefined;
    meta?: any | undefined;
    tags?: Tag[] | undefined;
    recordingMeta?: any | undefined;

    constructor(data?: IAddMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            this.recordingStartUtc = _data["recordingStartUtc"] ? new Date(_data["recordingStartUtc"].toString()) : <any>undefined;
            this.recordingEndUtc = _data["recordingEndUtc"] ? new Date(_data["recordingEndUtc"].toString()) : <any>undefined;
            this.organizer = _data["organizer"] ? AddParticipantRequest.fromJS(_data["organizer"]) : <any>undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(AddParticipantRequest.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            this.meta = _data["meta"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.recordingMeta = _data["recordingMeta"];
        }
    }

    static fromJS(data: any): AddMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        data["recordingStartUtc"] = this.recordingStartUtc ? this.recordingStartUtc.toISOString() : <any>undefined;
        data["recordingEndUtc"] = this.recordingEndUtc ? this.recordingEndUtc.toISOString() : <any>undefined;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : <any>undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["meta"] = this.meta;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["recordingMeta"] = this.recordingMeta;
        return data;
    }
}

export interface IAddMeetingRequest {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    organizer?: AddParticipantRequest;
    participants?: AddParticipantRequest[] | undefined;
    locations?: Location[] | undefined;
    meta?: any | undefined;
    tags?: Tag[] | undefined;
    recordingMeta?: any | undefined;
}

export class AddParticipantRequest implements IAddParticipantRequest {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    externalIds?: ParticipantId[] | undefined;

    constructor(data?: IAddParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            if (Array.isArray(_data["externalIds"])) {
                this.externalIds = [] as any;
                for (let item of _data["externalIds"])
                    this.externalIds!.push(ParticipantId.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        if (Array.isArray(this.externalIds)) {
            data["externalIds"] = [];
            for (let item of this.externalIds)
                data["externalIds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddParticipantRequest {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    externalIds?: ParticipantId[] | undefined;
}

export class AddTranscriptRequest implements IAddTranscriptRequest {
    id?: string;
    speakerFileName?: string | undefined;
    speakerTranscript?: SpeakerTranscriptJson;

    constructor(data?: IAddTranscriptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.speakerFileName = _data["speakerFileName"];
            this.speakerTranscript = _data["speakerTranscript"] ? SpeakerTranscriptJson.fromJS(_data["speakerTranscript"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddTranscriptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTranscriptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["speakerFileName"] = this.speakerFileName;
        data["speakerTranscript"] = this.speakerTranscript ? this.speakerTranscript.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddTranscriptRequest {
    id?: string;
    speakerFileName?: string | undefined;
    speakerTranscript?: SpeakerTranscriptJson;
}

export class Agenda implements IAgenda {
    showInSummary?: boolean;
    items?: AgendaItem[] | undefined;

    constructor(data?: IAgenda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showInSummary = _data["showInSummary"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgendaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Agenda {
        data = typeof data === 'object' ? data : {};
        let result = new Agenda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showInSummary"] = this.showInSummary;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgenda {
    showInSummary?: boolean;
    items?: AgendaItem[] | undefined;
}

export class AgendaItem implements IAgendaItem {
    id?: string;
    text?: string | undefined;
    annotation?: string | undefined;
    speakers?: string[] | undefined;

    constructor(data?: IAgendaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.annotation = _data["annotation"];
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(item);
            }
        }
    }

    static fromJS(data: any): AgendaItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["annotation"] = this.annotation;
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item);
        }
        return data;
    }
}

export interface IAgendaItem {
    id?: string;
    text?: string | undefined;
    annotation?: string | undefined;
    speakers?: string[] | undefined;
}

export class BackendVersionInfo implements IBackendVersionInfo {
    database?: DatabaseVersionInfo;

    constructor(data?: IBackendVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.database = _data["database"] ? DatabaseVersionInfo.fromJS(_data["database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BackendVersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BackendVersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBackendVersionInfo {
    database?: DatabaseVersionInfo;
}

export class DatabaseVersionInfo implements IDatabaseVersionInfo {
    actualVersion?: string | undefined;
    version?: string | undefined;

    constructor(data?: IDatabaseVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualVersion = _data["actualVersion"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): DatabaseVersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseVersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualVersion"] = this.actualVersion;
        data["version"] = this.version;
        return data;
    }
}

export interface IDatabaseVersionInfo {
    actualVersion?: string | undefined;
    version?: string | undefined;
}

export class DuplicateRequest implements IDuplicateRequest {
    copyTranscripts?: boolean;
    copySummary?: boolean;
    subjectSuffix?: string | undefined;

    constructor(data?: IDuplicateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copyTranscripts = _data["copyTranscripts"];
            this.copySummary = _data["copySummary"];
            this.subjectSuffix = _data["subjectSuffix"];
        }
    }

    static fromJS(data: any): DuplicateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copyTranscripts"] = this.copyTranscripts;
        data["copySummary"] = this.copySummary;
        data["subjectSuffix"] = this.subjectSuffix;
        return data;
    }
}

export interface IDuplicateRequest {
    copyTranscripts?: boolean;
    copySummary?: boolean;
    subjectSuffix?: string | undefined;
}

export class FileShortInfo implements IFileShortInfo {
    name?: string | undefined;
    size?: number;
    dateCreated?: Date | undefined;

    constructor(data?: IFileShortInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.size = _data["size"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileShortInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FileShortInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["size"] = this.size;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileShortInfo {
    name?: string | undefined;
    size?: number;
    dateCreated?: Date | undefined;
}

export class JsClientSettings implements IJsClientSettings {
    clientRoot?: string | undefined;
    authority?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    clientScope?: string | undefined;
    responseType?: string | undefined;
    metricsEnabled?: boolean;
    defaultSummaryBlockNames?: string[] | undefined;
    defaultSummaryBlocksWithAgenda?: string[] | undefined;
    showNER?: boolean;
    hideSummarization?: boolean;
    hideAgenda?: boolean;
    version?: BackendVersionInfo;
    maxReconstructedUttLength?: number;

    constructor(data?: IJsClientSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientRoot = _data["clientRoot"];
            this.authority = _data["authority"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.clientScope = _data["clientScope"];
            this.responseType = _data["responseType"];
            this.metricsEnabled = _data["metricsEnabled"];
            if (Array.isArray(_data["defaultSummaryBlockNames"])) {
                this.defaultSummaryBlockNames = [] as any;
                for (let item of _data["defaultSummaryBlockNames"])
                    this.defaultSummaryBlockNames!.push(item);
            }
            if (Array.isArray(_data["defaultSummaryBlocksWithAgenda"])) {
                this.defaultSummaryBlocksWithAgenda = [] as any;
                for (let item of _data["defaultSummaryBlocksWithAgenda"])
                    this.defaultSummaryBlocksWithAgenda!.push(item);
            }
            this.showNER = _data["showNER"];
            this.hideSummarization = _data["hideSummarization"];
            this.hideAgenda = _data["hideAgenda"];
            this.version = _data["version"] ? BackendVersionInfo.fromJS(_data["version"]) : <any>undefined;
            this.maxReconstructedUttLength = _data["maxReconstructedUttLength"];
        }
    }

    static fromJS(data: any): JsClientSettings {
        data = typeof data === 'object' ? data : {};
        let result = new JsClientSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientRoot"] = this.clientRoot;
        data["authority"] = this.authority;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["clientScope"] = this.clientScope;
        data["responseType"] = this.responseType;
        data["metricsEnabled"] = this.metricsEnabled;
        if (Array.isArray(this.defaultSummaryBlockNames)) {
            data["defaultSummaryBlockNames"] = [];
            for (let item of this.defaultSummaryBlockNames)
                data["defaultSummaryBlockNames"].push(item);
        }
        if (Array.isArray(this.defaultSummaryBlocksWithAgenda)) {
            data["defaultSummaryBlocksWithAgenda"] = [];
            for (let item of this.defaultSummaryBlocksWithAgenda)
                data["defaultSummaryBlocksWithAgenda"].push(item);
        }
        data["showNER"] = this.showNER;
        data["hideSummarization"] = this.hideSummarization;
        data["hideAgenda"] = this.hideAgenda;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["maxReconstructedUttLength"] = this.maxReconstructedUttLength;
        return data;
    }
}

export interface IJsClientSettings {
    clientRoot?: string | undefined;
    authority?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    clientScope?: string | undefined;
    responseType?: string | undefined;
    metricsEnabled?: boolean;
    defaultSummaryBlockNames?: string[] | undefined;
    defaultSummaryBlocksWithAgenda?: string[] | undefined;
    showNER?: boolean;
    hideSummarization?: boolean;
    hideAgenda?: boolean;
    version?: BackendVersionInfo;
    maxReconstructedUttLength?: number;
}

export class Location implements ILocation {
    id?: string;
    title?: string | undefined;
    meta?: any | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.meta = _data["meta"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["meta"] = this.meta;
        return data;
    }
}

export interface ILocation {
    id?: string;
    title?: string | undefined;
    meta?: any | undefined;
}

export class LocationInfo implements ILocationInfo {
    id?: string;
    title?: string | undefined;

    constructor(data?: ILocationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): LocationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LocationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface ILocationInfo {
    id?: string;
    title?: string | undefined;
}

export class MLTranscripts implements IMLTranscripts {
    transcripts?: SpeakerTranscript[] | undefined;

    constructor(data?: IMLTranscripts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transcripts"])) {
                this.transcripts = [] as any;
                for (let item of _data["transcripts"])
                    this.transcripts!.push(SpeakerTranscript.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MLTranscripts {
        data = typeof data === 'object' ? data : {};
        let result = new MLTranscripts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transcripts)) {
            data["transcripts"] = [];
            for (let item of this.transcripts)
                data["transcripts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMLTranscripts {
    transcripts?: SpeakerTranscript[] | undefined;
}

export class Meeting implements IMeeting {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    organizer?: Participant;
    participants?: Participant[] | undefined;
    locations?: Location[] | undefined;
    meta?: any | undefined;
    tags?: Tag[] | undefined;
    recordingMeta?: any | undefined;
    status?: MeetingStatus;
    plannedRecAgent?: RecordingAgentReg;
    plannedRecAgentConfig?: RecordingAgentSettings;
    plannedRecAgentId?: string | undefined;
    agenda?: Agenda;
    summaryMeta?: any | undefined;
    summaryBlocks?: SummaryBlock[] | undefined;
    transcriptMeta?: string | undefined;
    transcriptText!: string;

    constructor(data?: IMeeting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            this.recordingStartUtc = _data["recordingStartUtc"] ? new Date(_data["recordingStartUtc"].toString()) : <any>undefined;
            this.recordingEndUtc = _data["recordingEndUtc"] ? new Date(_data["recordingEndUtc"].toString()) : <any>undefined;
            this.organizer = _data["organizer"] ? Participant.fromJS(_data["organizer"]) : <any>undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(Participant.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            this.meta = _data["meta"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.recordingMeta = _data["recordingMeta"];
            this.status = _data["status"] ? MeetingStatus.fromJS(_data["status"]) : <any>undefined;
            this.plannedRecAgent = _data["plannedRecAgent"] ? RecordingAgentReg.fromJS(_data["plannedRecAgent"]) : <any>undefined;
            this.plannedRecAgentConfig = _data["plannedRecAgentConfig"] ? RecordingAgentSettings.fromJS(_data["plannedRecAgentConfig"]) : <any>undefined;
            this.plannedRecAgentId = _data["plannedRecAgentId"];
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
            this.summaryMeta = _data["summaryMeta"];
            if (Array.isArray(_data["summaryBlocks"])) {
                this.summaryBlocks = [] as any;
                for (let item of _data["summaryBlocks"])
                    this.summaryBlocks!.push(SummaryBlock.fromJS(item));
            }
            this.transcriptMeta = _data["transcriptMeta"];
            this.transcriptText = _data["transcriptText"];
        }
    }

    static fromJS(data: any): Meeting {
        data = typeof data === 'object' ? data : {};
        let result = new Meeting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        data["recordingStartUtc"] = this.recordingStartUtc ? this.recordingStartUtc.toISOString() : <any>undefined;
        data["recordingEndUtc"] = this.recordingEndUtc ? this.recordingEndUtc.toISOString() : <any>undefined;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : <any>undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["meta"] = this.meta;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["recordingMeta"] = this.recordingMeta;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["plannedRecAgent"] = this.plannedRecAgent ? this.plannedRecAgent.toJSON() : <any>undefined;
        data["plannedRecAgentConfig"] = this.plannedRecAgentConfig ? this.plannedRecAgentConfig.toJSON() : <any>undefined;
        data["plannedRecAgentId"] = this.plannedRecAgentId;
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        data["summaryMeta"] = this.summaryMeta;
        if (Array.isArray(this.summaryBlocks)) {
            data["summaryBlocks"] = [];
            for (let item of this.summaryBlocks)
                data["summaryBlocks"].push(item.toJSON());
        }
        data["transcriptMeta"] = this.transcriptMeta;
        data["transcriptText"] = this.transcriptText;
        return data;
    }
}

export interface IMeeting {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    organizer?: Participant;
    participants?: Participant[] | undefined;
    locations?: Location[] | undefined;
    meta?: any | undefined;
    tags?: Tag[] | undefined;
    recordingMeta?: any | undefined;
    status?: MeetingStatus;
    plannedRecAgent?: RecordingAgentReg;
    plannedRecAgentConfig?: RecordingAgentSettings;
    plannedRecAgentId?: string | undefined;
    agenda?: Agenda;
    summaryMeta?: any | undefined;
    summaryBlocks?: SummaryBlock[] | undefined;
    transcriptMeta?: string | undefined;
    transcriptText: string;
}

export enum MeetingActions {
    ProcessingComplete = "ProcessingComplete",
    TakeToWork = "TakeToWork",
    Complete = "Complete",
    ReturnToWork = "ReturnToWork",
    StartRecording = "StartRecording",
    StopRecording = "StopRecording",
    CompleteAndSendTasks = "CompleteAndSendTasks",
}

export class MeetingInfo implements IMeetingInfo {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    organizer?: ParticipantInfo;
    participants?: ParticipantInfo[] | undefined;
    locations?: LocationInfo[] | undefined;
    summaryMeta?: any | undefined;
    summaryBlocks?: SummaryBlock[] | undefined;
    tags?: Tag[] | undefined;
    hasAudio?: boolean;
    hasVideo?: boolean;
    status?: MeetingStatus;
    stateMachine?: MeetingStateMachine;
    agenda?: Agenda;
    isOwn?: boolean;
    transcriptMeta?: string | undefined;
    transcriptText?: string | undefined;

    constructor(data?: IMeetingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            this.organizer = _data["organizer"] ? ParticipantInfo.fromJS(_data["organizer"]) : <any>undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantInfo.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationInfo.fromJS(item));
            }
            this.summaryMeta = _data["summaryMeta"];
            if (Array.isArray(_data["summaryBlocks"])) {
                this.summaryBlocks = [] as any;
                for (let item of _data["summaryBlocks"])
                    this.summaryBlocks!.push(SummaryBlock.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.hasAudio = _data["hasAudio"];
            this.hasVideo = _data["hasVideo"];
            this.status = _data["status"] ? MeetingStatus.fromJS(_data["status"]) : <any>undefined;
            this.stateMachine = _data["stateMachine"] ? MeetingStateMachine.fromJS(_data["stateMachine"]) : <any>undefined;
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
            this.isOwn = _data["isOwn"];
            this.transcriptMeta = _data["transcriptMeta"];
            this.transcriptText = _data["transcriptText"];
        }
    }

    static fromJS(data: any): MeetingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : <any>undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["summaryMeta"] = this.summaryMeta;
        if (Array.isArray(this.summaryBlocks)) {
            data["summaryBlocks"] = [];
            for (let item of this.summaryBlocks)
                data["summaryBlocks"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["hasAudio"] = this.hasAudio;
        data["hasVideo"] = this.hasVideo;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["stateMachine"] = this.stateMachine ? this.stateMachine.toJSON() : <any>undefined;
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        data["isOwn"] = this.isOwn;
        data["transcriptMeta"] = this.transcriptMeta;
        data["transcriptText"] = this.transcriptText;
        return data;
    }
}

export interface IMeetingInfo {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    organizer?: ParticipantInfo;
    participants?: ParticipantInfo[] | undefined;
    locations?: LocationInfo[] | undefined;
    summaryMeta?: any | undefined;
    summaryBlocks?: SummaryBlock[] | undefined;
    tags?: Tag[] | undefined;
    hasAudio?: boolean;
    hasVideo?: boolean;
    status?: MeetingStatus;
    stateMachine?: MeetingStateMachine;
    agenda?: Agenda;
    isOwn?: boolean;
    transcriptMeta?: string | undefined;
    transcriptText?: string | undefined;
}

export class MeetingList implements IMeetingList {
    meetings?: MeetingListItem[] | undefined;
    paginationResponce?: PaginationResponce;

    constructor(data?: IMeetingList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["meetings"])) {
                this.meetings = [] as any;
                for (let item of _data["meetings"])
                    this.meetings!.push(MeetingListItem.fromJS(item));
            }
            this.paginationResponce = _data["paginationResponce"] ? PaginationResponce.fromJS(_data["paginationResponce"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MeetingList {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.meetings)) {
            data["meetings"] = [];
            for (let item of this.meetings)
                data["meetings"].push(item.toJSON());
        }
        data["paginationResponce"] = this.paginationResponce ? this.paginationResponce.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeetingList {
    meetings?: MeetingListItem[] | undefined;
    paginationResponce?: PaginationResponce;
}

export class MeetingListItem implements IMeetingListItem {
    id?: string;
    subject?: string | undefined;
    status?: MeetingStatusInfo;
    recorderStatus?: RecorderStatusEnum;
    recordedDurationMs?: number | undefined;
    lastRecordingSpanStartUtc?: Date | undefined;
    plannedRecAgentId?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    isOwn?: boolean;
    tasks?: TaskLink[] | undefined;
    transcriptSearchResult?: string | undefined;
    organizationName?: string | undefined;

    constructor(data?: IMeetingListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.status = _data["status"] ? MeetingStatusInfo.fromJS(_data["status"]) : <any>undefined;
            this.recorderStatus = _data["recorderStatus"];
            this.recordedDurationMs = _data["recordedDurationMs"];
            this.lastRecordingSpanStartUtc = _data["lastRecordingSpanStartUtc"] ? new Date(_data["lastRecordingSpanStartUtc"].toString()) : <any>undefined;
            this.plannedRecAgentId = _data["plannedRecAgentId"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            this.recordingStartUtc = _data["recordingStartUtc"] ? new Date(_data["recordingStartUtc"].toString()) : <any>undefined;
            this.recordingEndUtc = _data["recordingEndUtc"] ? new Date(_data["recordingEndUtc"].toString()) : <any>undefined;
            this.isOwn = _data["isOwn"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskLink.fromJS(item));
            }
            this.transcriptSearchResult = _data["transcriptSearchResult"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): MeetingListItem {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["recorderStatus"] = this.recorderStatus;
        data["recordedDurationMs"] = this.recordedDurationMs;
        data["lastRecordingSpanStartUtc"] = this.lastRecordingSpanStartUtc ? this.lastRecordingSpanStartUtc.toISOString() : <any>undefined;
        data["plannedRecAgentId"] = this.plannedRecAgentId;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        data["recordingStartUtc"] = this.recordingStartUtc ? this.recordingStartUtc.toISOString() : <any>undefined;
        data["recordingEndUtc"] = this.recordingEndUtc ? this.recordingEndUtc.toISOString() : <any>undefined;
        data["isOwn"] = this.isOwn;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["transcriptSearchResult"] = this.transcriptSearchResult;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IMeetingListItem {
    id?: string;
    subject?: string | undefined;
    status?: MeetingStatusInfo;
    recorderStatus?: RecorderStatusEnum;
    recordedDurationMs?: number | undefined;
    lastRecordingSpanStartUtc?: Date | undefined;
    plannedRecAgentId?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    isOwn?: boolean;
    tasks?: TaskLink[] | undefined;
    transcriptSearchResult?: string | undefined;
    organizationName?: string | undefined;
}

export class MeetingListRequest implements IMeetingListRequest {
    paginationQuery?: PaginationQuery;
    search?: MeetingListSearchQuery;
    showOrganizations?: boolean;

    constructor(data?: IMeetingListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginationQuery = _data["paginationQuery"] ? PaginationQuery.fromJS(_data["paginationQuery"]) : <any>undefined;
            this.search = _data["search"] ? MeetingListSearchQuery.fromJS(_data["search"]) : <any>undefined;
            this.showOrganizations = _data["showOrganizations"];
        }
    }

    static fromJS(data: any): MeetingListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginationQuery"] = this.paginationQuery ? this.paginationQuery.toJSON() : <any>undefined;
        data["search"] = this.search ? this.search.toJSON() : <any>undefined;
        data["showOrganizations"] = this.showOrganizations;
        return data;
    }
}

export interface IMeetingListRequest {
    paginationQuery?: PaginationQuery;
    search?: MeetingListSearchQuery;
    showOrganizations?: boolean;
}

export class MeetingListSearchQuery implements IMeetingListSearchQuery {
    quickSearch?: string | undefined;
    searchType?: MeetingListSearchType;
    subject?: string | undefined;
    participants?: ParticipantInfo[] | undefined;
    taskUri?: string | undefined;
    statuses?: MeetingStatusInfo[] | undefined;
    transcript?: string | undefined;
    startDateUtc_Start?: Date | undefined;
    startDateUtc_End?: Date | undefined;
    startTimeUtc_Start?: Date | undefined;
    startTimeUtc_End?: Date | undefined;

    constructor(data?: IMeetingListSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quickSearch = _data["quickSearch"];
            this.searchType = _data["searchType"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantInfo.fromJS(item));
            }
            this.taskUri = _data["taskUri"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(MeetingStatusInfo.fromJS(item));
            }
            this.transcript = _data["transcript"];
            this.startDateUtc_Start = _data["startDateUtc_Start"] ? new Date(_data["startDateUtc_Start"].toString()) : <any>undefined;
            this.startDateUtc_End = _data["startDateUtc_End"] ? new Date(_data["startDateUtc_End"].toString()) : <any>undefined;
            this.startTimeUtc_Start = _data["startTimeUtc_Start"] ? new Date(_data["startTimeUtc_Start"].toString()) : <any>undefined;
            this.startTimeUtc_End = _data["startTimeUtc_End"] ? new Date(_data["startTimeUtc_End"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeetingListSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingListSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quickSearch"] = this.quickSearch;
        data["searchType"] = this.searchType;
        data["subject"] = this.subject;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["taskUri"] = this.taskUri;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        data["transcript"] = this.transcript;
        data["startDateUtc_Start"] = this.startDateUtc_Start ? this.startDateUtc_Start.toISOString() : <any>undefined;
        data["startDateUtc_End"] = this.startDateUtc_End ? this.startDateUtc_End.toISOString() : <any>undefined;
        data["startTimeUtc_Start"] = this.startTimeUtc_Start ? this.startTimeUtc_Start.toISOString() : <any>undefined;
        data["startTimeUtc_End"] = this.startTimeUtc_End ? this.startTimeUtc_End.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMeetingListSearchQuery {
    quickSearch?: string | undefined;
    searchType?: MeetingListSearchType;
    subject?: string | undefined;
    participants?: ParticipantInfo[] | undefined;
    taskUri?: string | undefined;
    statuses?: MeetingStatusInfo[] | undefined;
    transcript?: string | undefined;
    startDateUtc_Start?: Date | undefined;
    startDateUtc_End?: Date | undefined;
    startTimeUtc_Start?: Date | undefined;
    startTimeUtc_End?: Date | undefined;
}

export enum MeetingListSearchType {
    Quick = "Quick",
    Advanced = "Advanced",
}

export class MeetingRecordingSettings implements IMeetingRecordingSettings {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    plannedRecAgentId?: string | undefined;
    plannedRecAgentName?: string | undefined;
    plannedRecAgentConfig?: RecordingAgentSettings;

    constructor(data?: IMeetingRecordingSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            this.plannedRecAgentId = _data["plannedRecAgentId"];
            this.plannedRecAgentName = _data["plannedRecAgentName"];
            this.plannedRecAgentConfig = _data["plannedRecAgentConfig"] ? RecordingAgentSettings.fromJS(_data["plannedRecAgentConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MeetingRecordingSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingRecordingSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        data["plannedRecAgentId"] = this.plannedRecAgentId;
        data["plannedRecAgentName"] = this.plannedRecAgentName;
        data["plannedRecAgentConfig"] = this.plannedRecAgentConfig ? this.plannedRecAgentConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeetingRecordingSettings {
    id?: string;
    subject?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    plannedRecAgentId?: string | undefined;
    plannedRecAgentName?: string | undefined;
    plannedRecAgentConfig?: RecordingAgentSettings;
}

export class MeetingStateMachine implements IMeetingStateMachine {
    statusId?: MeetingStatuses;
    readonly secondaryActions?: MeetingActions[] | undefined;
    readonly actions?: MeetingActions[] | undefined;

    constructor(data?: IMeetingStateMachine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["secondaryActions"])) {
                (<any>this).secondaryActions = [] as any;
                for (let item of _data["secondaryActions"])
                    (<any>this).secondaryActions!.push(item);
            }
            if (Array.isArray(_data["actions"])) {
                (<any>this).actions = [] as any;
                for (let item of _data["actions"])
                    (<any>this).actions!.push(item);
            }
        }
    }

    static fromJS(data: any): MeetingStateMachine {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingStateMachine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        if (Array.isArray(this.secondaryActions)) {
            data["secondaryActions"] = [];
            for (let item of this.secondaryActions)
                data["secondaryActions"].push(item);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        return data;
    }
}

export interface IMeetingStateMachine {
    statusId?: MeetingStatuses;
    secondaryActions?: MeetingActions[] | undefined;
    actions?: MeetingActions[] | undefined;
}

export class MeetingStatus implements IMeetingStatus {
    id?: string;
    name?: string | undefined;
    alias?: string | undefined;
    code?: number;

    constructor(data?: IMeetingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MeetingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["code"] = this.code;
        return data;
    }
}

export interface IMeetingStatus {
    id?: string;
    name?: string | undefined;
    alias?: string | undefined;
    code?: number;
}

export class MeetingStatusInfo implements IMeetingStatusInfo {
    id?: string;
    name?: string | undefined;
    alias?: string | undefined;
    code?: number;

    constructor(data?: IMeetingStatusInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MeetingStatusInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingStatusInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["code"] = this.code;
        return data;
    }
}

export interface IMeetingStatusInfo {
    id?: string;
    name?: string | undefined;
    alias?: string | undefined;
    code?: number;
}

export enum MeetingStatuses {
    Processing = "Processing",
    New = "New",
    InWork = "InWork",
    Done = "Done",
    Plan = "Plan",
    Record = "Record",
    Upload = "Upload",
}

export class MeetingTranscript_Request implements IMeetingTranscript_Request {
    transcriptText?: string | undefined;
    speakers?: ParticipantInfo[] | undefined;

    constructor(data?: IMeetingTranscript_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptText = _data["transcriptText"];
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(ParticipantInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingTranscript_Request {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTranscript_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptText"] = this.transcriptText;
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMeetingTranscript_Request {
    transcriptText?: string | undefined;
    speakers?: ParticipantInfo[] | undefined;
}

export class Organization implements IOrganization {
    id?: string;
    name?: string | undefined;

    constructor(data?: IOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganization {
    id?: string;
    name?: string | undefined;
}

export class PaginationQuery implements IPaginationQuery {
    currentPage?: number;
    descendingOrder?: boolean;
    pageSize?: number;

    constructor(data?: IPaginationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.descendingOrder = _data["descendingOrder"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaginationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["descendingOrder"] = this.descendingOrder;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPaginationQuery {
    currentPage?: number;
    descendingOrder?: boolean;
    pageSize?: number;
}

export class PaginationResponce implements IPaginationResponce {
    totalPages?: number;

    constructor(data?: IPaginationResponce) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginationResponce {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponce();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginationResponce {
    totalPages?: number;
}

export class Participant implements IParticipant {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
    voiceEmbedding?: string | undefined;
    organization?: Organization;

    constructor(data?: IParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.position = _data["position"];
            this.voiceEmbedding = _data["voiceEmbedding"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Participant {
        data = typeof data === 'object' ? data : {};
        let result = new Participant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["position"] = this.position;
        data["voiceEmbedding"] = this.voiceEmbedding;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParticipant {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
    voiceEmbedding?: string | undefined;
    organization?: Organization;
}

export class ParticipantId implements IParticipantId {
    id?: number;
    participant!: Participant;
    type!: string;
    value!: string;
    systemMeta?: any | undefined;

    constructor(data?: IParticipantId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.participant = new Participant();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participant = _data["participant"] ? Participant.fromJS(_data["participant"]) : new Participant();
            this.type = _data["type"];
            this.value = _data["value"];
            this.systemMeta = _data["systemMeta"];
        }
    }

    static fromJS(data: any): ParticipantId {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["systemMeta"] = this.systemMeta;
        return data;
    }
}

export interface IParticipantId {
    id?: number;
    participant: Participant;
    type: string;
    value: string;
    systemMeta?: any | undefined;
}

export class ParticipantInfo implements IParticipantInfo {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IParticipantInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ParticipantInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IParticipantInfo {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
}

export class ParticipantRenameInfo implements IParticipantRenameInfo {
    id?: string;
    name?: string | undefined;

    constructor(data?: IParticipantRenameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ParticipantRenameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantRenameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IParticipantRenameInfo {
    id?: string;
    name?: string | undefined;
}

export class RecorderAgentDevice implements IRecorderAgentDevice {
    internalId?: string | undefined;
    name?: string | undefined;
    api?: RecorderAgentDevice_API;
    readonly id?: string | undefined;
    channels?: RecorderAgentDeviceChannel[] | undefined;
    samplingRate?: number;
    bitness?: number;

    constructor(data?: IRecorderAgentDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"];
            this.name = _data["name"];
            this.api = _data["api"];
            (<any>this).id = _data["id"];
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(RecorderAgentDeviceChannel.fromJS(item));
            }
            this.samplingRate = _data["samplingRate"];
            this.bitness = _data["bitness"];
        }
    }

    static fromJS(data: any): RecorderAgentDevice {
        data = typeof data === 'object' ? data : {};
        let result = new RecorderAgentDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["name"] = this.name;
        data["api"] = this.api;
        data["id"] = this.id;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        data["samplingRate"] = this.samplingRate;
        data["bitness"] = this.bitness;
        return data;
    }
}

export interface IRecorderAgentDevice {
    internalId?: string | undefined;
    name?: string | undefined;
    api?: RecorderAgentDevice_API;
    id?: string | undefined;
    channels?: RecorderAgentDeviceChannel[] | undefined;
    samplingRate?: number;
    bitness?: number;
}

export class RecorderAgentDeviceChannel implements IRecorderAgentDeviceChannel {
    name?: string | undefined;
    enabled?: boolean;

    constructor(data?: IRecorderAgentDeviceChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): RecorderAgentDeviceChannel {
        data = typeof data === 'object' ? data : {};
        let result = new RecorderAgentDeviceChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IRecorderAgentDeviceChannel {
    name?: string | undefined;
    enabled?: boolean;
}

export enum RecorderAgentDevice_API {
    ASIO = "ASIO",
    WinMM = "WinMM",
    WASAPI = "WASAPI",
}

export enum RecorderStatusEnum {
    Ready = "Ready",
    Recording = "Recording",
    Paused = "Paused",
}

export class RecordingAgentReg implements IRecordingAgentReg {
    id?: string;
    name?: string | undefined;
    configuration?: RecordingAgentSettings;

    constructor(data?: IRecordingAgentReg) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.configuration = _data["configuration"] ? RecordingAgentSettings.fromJS(_data["configuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordingAgentReg {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingAgentReg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecordingAgentReg {
    id?: string;
    name?: string | undefined;
    configuration?: RecordingAgentSettings;
}

export class RecordingAgentRegInfo implements IRecordingAgentRegInfo {
    recordingAgentRegs?: RecordingAgentReg[] | undefined;
    activeAgents?: string[] | undefined;

    constructor(data?: IRecordingAgentRegInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recordingAgentRegs"])) {
                this.recordingAgentRegs = [] as any;
                for (let item of _data["recordingAgentRegs"])
                    this.recordingAgentRegs!.push(RecordingAgentReg.fromJS(item));
            }
            if (Array.isArray(_data["activeAgents"])) {
                this.activeAgents = [] as any;
                for (let item of _data["activeAgents"])
                    this.activeAgents!.push(item);
            }
        }
    }

    static fromJS(data: any): RecordingAgentRegInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingAgentRegInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recordingAgentRegs)) {
            data["recordingAgentRegs"] = [];
            for (let item of this.recordingAgentRegs)
                data["recordingAgentRegs"].push(item.toJSON());
        }
        if (Array.isArray(this.activeAgents)) {
            data["activeAgents"] = [];
            for (let item of this.activeAgents)
                data["activeAgents"].push(item);
        }
        return data;
    }
}

export interface IRecordingAgentRegInfo {
    recordingAgentRegs?: RecordingAgentReg[] | undefined;
    activeAgents?: string[] | undefined;
}

export class RecordingAgentSettings implements IRecordingAgentSettings {
    readonly version?: string | undefined;
    selectedDeviceId?: string | undefined;
    devices?: RecorderAgentDevice[] | undefined;

    constructor(data?: IRecordingAgentSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).version = _data["version"];
            this.selectedDeviceId = _data["selectedDeviceId"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(RecorderAgentDevice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecordingAgentSettings {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingAgentSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["selectedDeviceId"] = this.selectedDeviceId;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecordingAgentSettings {
    version?: string | undefined;
    selectedDeviceId?: string | undefined;
    devices?: RecorderAgentDevice[] | undefined;
}

export enum RecordingState {
    Uploaded = "Uploaded",
    Converted = "Converted",
    Transcribed = "Transcribed",
}

export class RecordingUpdateInfo implements IRecordingUpdateInfo {
    recordingId?: string;
    state?: RecordingState;
    force?: boolean;
    asrName?: string | undefined;
    asrModel?: string | undefined;
    attemptCount?: number;
    asrBatchSeconds?: number | undefined;
    languageCode?: string | undefined;
    diarization?: number | undefined;
    maxDiarizedSpeakers?: number | undefined;
    minLoudness?: number | undefined;
    minConfidence?: number | undefined;
    forcePunctuation?: boolean | undefined;
    disableNormalization?: boolean | undefined;

    constructor(data?: IRecordingUpdateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordingId = _data["recordingId"];
            this.state = _data["state"];
            this.force = _data["force"];
            this.asrName = _data["asrName"];
            this.asrModel = _data["asrModel"];
            this.attemptCount = _data["attemptCount"];
            this.asrBatchSeconds = _data["asrBatchSeconds"];
            this.languageCode = _data["languageCode"];
            this.diarization = _data["diarization"];
            this.maxDiarizedSpeakers = _data["maxDiarizedSpeakers"];
            this.minLoudness = _data["minLoudness"];
            this.minConfidence = _data["minConfidence"];
            this.forcePunctuation = _data["forcePunctuation"];
            this.disableNormalization = _data["disableNormalization"];
        }
    }

    static fromJS(data: any): RecordingUpdateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingUpdateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordingId"] = this.recordingId;
        data["state"] = this.state;
        data["force"] = this.force;
        data["asrName"] = this.asrName;
        data["asrModel"] = this.asrModel;
        data["attemptCount"] = this.attemptCount;
        data["asrBatchSeconds"] = this.asrBatchSeconds;
        data["languageCode"] = this.languageCode;
        data["diarization"] = this.diarization;
        data["maxDiarizedSpeakers"] = this.maxDiarizedSpeakers;
        data["minLoudness"] = this.minLoudness;
        data["minConfidence"] = this.minConfidence;
        data["forcePunctuation"] = this.forcePunctuation;
        data["disableNormalization"] = this.disableNormalization;
        return data;
    }
}

export interface IRecordingUpdateInfo {
    recordingId?: string;
    state?: RecordingState;
    force?: boolean;
    asrName?: string | undefined;
    asrModel?: string | undefined;
    attemptCount?: number;
    asrBatchSeconds?: number | undefined;
    languageCode?: string | undefined;
    diarization?: number | undefined;
    maxDiarizedSpeakers?: number | undefined;
    minLoudness?: number | undefined;
    minConfidence?: number | undefined;
    forcePunctuation?: boolean | undefined;
    disableNormalization?: boolean | undefined;
}

export class SpeakerFileInfo implements ISpeakerFileInfo {
    fileName?: string | undefined;
    lastASRDateUtc?: Date | undefined;
    delayInSeconds?: number;

    constructor(data?: ISpeakerFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.lastASRDateUtc = _data["lastASRDateUtc"] ? new Date(_data["lastASRDateUtc"].toString()) : <any>undefined;
            this.delayInSeconds = _data["delayInSeconds"];
        }
    }

    static fromJS(data: any): SpeakerFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["lastASRDateUtc"] = this.lastASRDateUtc ? this.lastASRDateUtc.toISOString() : <any>undefined;
        data["delayInSeconds"] = this.delayInSeconds;
        return data;
    }
}

export interface ISpeakerFileInfo {
    fileName?: string | undefined;
    lastASRDateUtc?: Date | undefined;
    delayInSeconds?: number;
}

export class SpeakerTranscript implements ISpeakerTranscript {
    id?: string;
    speakerId?: string;
    speakerName?: string | undefined;
    text?: any | undefined;
    asrName?: string | undefined;

    constructor(data?: ISpeakerTranscript) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.text = _data["text"];
            this.asrName = _data["asrName"];
        }
    }

    static fromJS(data: any): SpeakerTranscript {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerTranscript();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["text"] = this.text;
        data["asrName"] = this.asrName;
        return data;
    }
}

export interface ISpeakerTranscript {
    id?: string;
    speakerId?: string;
    speakerName?: string | undefined;
    text?: any | undefined;
    asrName?: string | undefined;
}

export class SpeakerTranscriptJson implements ISpeakerTranscriptJson {
    created_date?: Date | undefined;
    raw?: string | undefined;
    meta?: SpeakerTranscriptJson_Meta;
    speaker?: SpeakerTranscriptJson_Speaker;
    rows?: SpeakerTranscriptJson_Utt[] | undefined;

    [key: string]: any;

    constructor(data?: ISpeakerTranscriptJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.created_date = _data["created_date"] ? new Date(_data["created_date"].toString()) : <any>undefined;
            this.raw = _data["raw"];
            this.meta = _data["meta"] ? SpeakerTranscriptJson_Meta.fromJS(_data["meta"]) : <any>undefined;
            this.speaker = _data["speaker"] ? SpeakerTranscriptJson_Speaker.fromJS(_data["speaker"]) : <any>undefined;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SpeakerTranscriptJson_Utt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpeakerTranscriptJson {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerTranscriptJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["created_date"] = this.created_date ? this.created_date.toISOString() : <any>undefined;
        data["raw"] = this.raw;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        data["speaker"] = this.speaker ? this.speaker.toJSON() : <any>undefined;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISpeakerTranscriptJson {
    created_date?: Date | undefined;
    raw?: string | undefined;
    meta?: SpeakerTranscriptJson_Meta;
    speaker?: SpeakerTranscriptJson_Speaker;
    rows?: SpeakerTranscriptJson_Utt[] | undefined;

    [key: string]: any;
}

export class SpeakerTranscriptJson_Meta implements ISpeakerTranscriptJson_Meta {
    asrSystem?: string | undefined;

    [key: string]: any;

    constructor(data?: ISpeakerTranscriptJson_Meta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.asrSystem = _data["asrSystem"];
        }
    }

    static fromJS(data: any): SpeakerTranscriptJson_Meta {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerTranscriptJson_Meta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["asrSystem"] = this.asrSystem;
        return data;
    }
}

export interface ISpeakerTranscriptJson_Meta {
    asrSystem?: string | undefined;

    [key: string]: any;
}

export class SpeakerTranscriptJson_Speaker implements ISpeakerTranscriptJson_Speaker {
    id?: string;
    name?: string | undefined;

    [key: string]: any;

    constructor(data?: ISpeakerTranscriptJson_Speaker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SpeakerTranscriptJson_Speaker {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerTranscriptJson_Speaker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISpeakerTranscriptJson_Speaker {
    id?: string;
    name?: string | undefined;

    [key: string]: any;
}

export class SpeakerTranscriptJson_Utt implements ISpeakerTranscriptJson_Utt {
    id?: string | undefined;
    startTicks?: number;
    durationTicks?: number;
    text?: string | undefined;
    isManual?: boolean | undefined;
    words?: SpeakerTranscriptJson_Word[] | undefined;
    diarizedSpeakerId?: string | undefined;

    [key: string]: any;

    constructor(data?: ISpeakerTranscriptJson_Utt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["Id"];
            this.startTicks = _data["StartTicks"];
            this.durationTicks = _data["DurationTicks"];
            this.text = _data["Text"];
            this.isManual = _data["IsManual"];
            if (Array.isArray(_data["Words"])) {
                this.words = [] as any;
                for (let item of _data["Words"])
                    this.words!.push(SpeakerTranscriptJson_Word.fromJS(item));
            }
            this.diarizedSpeakerId = _data["DiarizedSpeakerId"];
        }
    }

    static fromJS(data: any): SpeakerTranscriptJson_Utt {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerTranscriptJson_Utt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Id"] = this.id;
        data["StartTicks"] = this.startTicks;
        data["DurationTicks"] = this.durationTicks;
        data["Text"] = this.text;
        data["IsManual"] = this.isManual;
        if (Array.isArray(this.words)) {
            data["Words"] = [];
            for (let item of this.words)
                data["Words"].push(item.toJSON());
        }
        data["DiarizedSpeakerId"] = this.diarizedSpeakerId;
        return data;
    }
}

export interface ISpeakerTranscriptJson_Utt {
    id?: string | undefined;
    startTicks?: number;
    durationTicks?: number;
    text?: string | undefined;
    isManual?: boolean | undefined;
    words?: SpeakerTranscriptJson_Word[] | undefined;
    diarizedSpeakerId?: string | undefined;

    [key: string]: any;
}

export class SpeakerTranscriptJson_Word implements ISpeakerTranscriptJson_Word {
    startTicks?: number;
    durationTicks?: number;
    text?: string | undefined;

    [key: string]: any;

    constructor(data?: ISpeakerTranscriptJson_Word) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.startTicks = _data["StartTicks"];
            this.durationTicks = _data["DurationTicks"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): SpeakerTranscriptJson_Word {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerTranscriptJson_Word();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["StartTicks"] = this.startTicks;
        data["DurationTicks"] = this.durationTicks;
        data["Text"] = this.text;
        return data;
    }
}

export interface ISpeakerTranscriptJson_Word {
    startTicks?: number;
    durationTicks?: number;
    text?: string | undefined;

    [key: string]: any;
}

export class SummaryBlock implements ISummaryBlock {
    items?: SummaryBlockItem[] | undefined;
    blockName?: string | undefined;
    blockNameType?: number;
    showAgenda?: boolean;

    __data: SummaryBlockExtData = new SummaryBlockExtData();

    __updateData(agenda: Agenda) {
        const agendaItemsIds = agenda && agenda.items && agenda.items.map(item => item.id) || [];

        this.__data = new SummaryBlockExtData();
        this.__data.items = this.items.filter(item => !item.agendaItemId || !agendaItemsIds.includes(item.agendaItemId));
        this.items.filter(item => item.agendaItemId && agendaItemsIds.includes(item.agendaItemId)).forEach(item => {
            if (!(item.agendaItemId in this.__data.agendaItems)) {
                this.__data.agendaItems[item.agendaItemId] = [];
            }
            this.__data.agendaItems[item.agendaItemId].push(item);
        });

        this.__data.items.forEach(item => {
            if (item.agendaItemId && !agendaItemsIds.includes(item.agendaItemId)) {
                item.agendaItemId = null;
            }
        })
    }

    constructor(data?: ISummaryBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SummaryBlockItem.fromJS(item));
            }
            this.blockName = _data["blockName"];
            this.blockNameType = _data["blockNameType"];
            this.showAgenda = _data["showAgenda"];
        }
    }

    static fromJS(data: any): SummaryBlock {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["blockName"] = this.blockName;
        data["blockNameType"] = this.blockNameType;
        data["showAgenda"] = this.showAgenda;
        return data;
    }
}

export interface ISummaryBlock {
    items?: SummaryBlockItem[] | undefined;
    blockName?: string | undefined;
    blockNameType?: number;
    showAgenda?: boolean;
}

export class SummaryBlockDate implements ISummaryBlockDate {
    start?: number;
    length?: number;
    text?: string | undefined;
    value?: Date | undefined;

    constructor(data?: ISummaryBlockDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"];
            this.length = _data["length"];
            this.text = _data["text"];
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryBlockDate {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryBlockDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["length"] = this.length;
        data["text"] = this.text;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISummaryBlockDate {
    start?: number;
    length?: number;
    text?: string | undefined;
    value?: Date | undefined;
}

export class SummaryBlockItem implements ISummaryBlockItem {
    id?: string;
    text?: string | undefined;
    isAuto?: boolean;
    persons?: SummaryBlockPerson[] | undefined;
    selectedPersons?: ParticipantInfo[] | undefined;
    dates?: SummaryBlockDate[] | undefined;
    autoType?: string | undefined;
    agendaItemId?: string | undefined;
    transcriptRowIds?: string[] | undefined;
    selectedDate?: Date | undefined;
    taskLink?: TaskLink;

    constructor(data?: ISummaryBlockItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.isAuto = _data["isAuto"];
            if (Array.isArray(_data["persons"])) {
                this.persons = [] as any;
                for (let item of _data["persons"])
                    this.persons!.push(SummaryBlockPerson.fromJS(item));
            }
            if (Array.isArray(_data["selectedPersons"])) {
                this.selectedPersons = [] as any;
                for (let item of _data["selectedPersons"])
                    this.selectedPersons!.push(ParticipantInfo.fromJS(item));
            }
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(SummaryBlockDate.fromJS(item));
            }
            this.autoType = _data["autoType"];
            this.agendaItemId = _data["agendaItemId"];
            if (Array.isArray(_data["transcriptRowIds"])) {
                this.transcriptRowIds = [] as any;
                for (let item of _data["transcriptRowIds"])
                    this.transcriptRowIds!.push(item);
            }
            this.selectedDate = _data["selectedDate"] ? new Date(_data["selectedDate"].toString()) : <any>undefined;
            this.taskLink = _data["taskLink"] ? TaskLink.fromJS(_data["taskLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryBlockItem {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryBlockItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["isAuto"] = this.isAuto;
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedPersons)) {
            data["selectedPersons"] = [];
            for (let item of this.selectedPersons)
                data["selectedPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        data["autoType"] = this.autoType;
        data["agendaItemId"] = this.agendaItemId;
        if (Array.isArray(this.transcriptRowIds)) {
            data["transcriptRowIds"] = [];
            for (let item of this.transcriptRowIds)
                data["transcriptRowIds"].push(item);
        }
        data["selectedDate"] = this.selectedDate ? this.selectedDate.toISOString() : <any>undefined;
        data["taskLink"] = this.taskLink ? this.taskLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISummaryBlockItem {
    id?: string;
    text?: string | undefined;
    isAuto?: boolean;
    persons?: SummaryBlockPerson[] | undefined;
    selectedPersons?: ParticipantInfo[] | undefined;
    dates?: SummaryBlockDate[] | undefined;
    autoType?: string | undefined;
    agendaItemId?: string | undefined;
    transcriptRowIds?: string[] | undefined;
    selectedDate?: Date | undefined;
    taskLink?: TaskLink;
}

export class SummaryBlockPerson implements ISummaryBlockPerson {
    name?: string | undefined;
    value?: string | undefined;
    start?: number;
    length?: number;
    info?: ParticipantInfo;

    constructor(data?: ISummaryBlockPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.start = _data["start"];
            this.length = _data["length"];
            this.info = _data["info"] ? ParticipantInfo.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryBlockPerson {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryBlockPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["start"] = this.start;
        data["length"] = this.length;
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISummaryBlockPerson {
    name?: string | undefined;
    value?: string | undefined;
    start?: number;
    length?: number;
    info?: ParticipantInfo;
}

export class SummaryBlocksWithMeta implements ISummaryBlocksWithMeta {
    summaryMeta?: any | undefined;
    summaryBlocks?: SummaryBlock[] | undefined;

    constructor(data?: ISummaryBlocksWithMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summaryMeta = _data["summaryMeta"];
            if (Array.isArray(_data["summaryBlocks"])) {
                this.summaryBlocks = [] as any;
                for (let item of _data["summaryBlocks"])
                    this.summaryBlocks!.push(SummaryBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SummaryBlocksWithMeta {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryBlocksWithMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryMeta"] = this.summaryMeta;
        if (Array.isArray(this.summaryBlocks)) {
            data["summaryBlocks"] = [];
            for (let item of this.summaryBlocks)
                data["summaryBlocks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISummaryBlocksWithMeta {
    summaryMeta?: any | undefined;
    summaryBlocks?: SummaryBlock[] | undefined;
}

export class SummaryDataForML implements ISummaryDataForML {
    participants?: ParticipantInfo[] | undefined;
    transcript?: TranscriptRowForML[] | undefined;
    totalTicks?: number;
    meetingDateUtc?: Date;

    constructor(data?: ISummaryDataForML) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantInfo.fromJS(item));
            }
            if (Array.isArray(_data["transcript"])) {
                this.transcript = [] as any;
                for (let item of _data["transcript"])
                    this.transcript!.push(TranscriptRowForML.fromJS(item));
            }
            this.totalTicks = _data["totalTicks"];
            this.meetingDateUtc = _data["meetingDateUtc"] ? new Date(_data["meetingDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryDataForML {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDataForML();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.transcript)) {
            data["transcript"] = [];
            for (let item of this.transcript)
                data["transcript"].push(item.toJSON());
        }
        data["totalTicks"] = this.totalTicks;
        data["meetingDateUtc"] = this.meetingDateUtc ? this.meetingDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISummaryDataForML {
    participants?: ParticipantInfo[] | undefined;
    transcript?: TranscriptRowForML[] | undefined;
    totalTicks?: number;
    meetingDateUtc?: Date;
}

export class Tag implements ITag {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITag {
    id?: number;
    name?: string | undefined;
}

export class TaskLink implements ITaskLink {
    kind?: string | undefined;
    uri?: string | undefined;

    constructor(data?: ITaskLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): TaskLink {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["uri"] = this.uri;
        return data;
    }
}

export interface ITaskLink {
    kind?: string | undefined;
    uri?: string | undefined;
}

export class ToggleShowAgendaRequest implements IToggleShowAgendaRequest {
    agenda?: Agenda;
    summaryRequest?: UpdateSummaryRequest;

    constructor(data?: IToggleShowAgendaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
            this.summaryRequest = _data["summaryRequest"] ? UpdateSummaryRequest.fromJS(_data["summaryRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ToggleShowAgendaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleShowAgendaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        data["summaryRequest"] = this.summaryRequest ? this.summaryRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IToggleShowAgendaRequest {
    agenda?: Agenda;
    summaryRequest?: UpdateSummaryRequest;
}

export class ToggleShowAgendaResponse implements IToggleShowAgendaResponse {
    summary?: SummaryBlocksWithMeta;
    agenda?: Agenda;

    constructor(data?: IToggleShowAgendaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? SummaryBlocksWithMeta.fromJS(_data["summary"]) : <any>undefined;
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ToggleShowAgendaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleShowAgendaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        return data;
    }
}

export interface IToggleShowAgendaResponse {
    summary?: SummaryBlocksWithMeta;
    agenda?: Agenda;
}

export class TranscriptInfo implements ITranscriptInfo {
    transcriptMeta?: string | undefined;
    transcriptText?: string | undefined;
    participants?: ParticipantInfo[] | undefined;

    constructor(data?: ITranscriptInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptMeta = _data["transcriptMeta"];
            this.transcriptText = _data["transcriptText"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranscriptInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptMeta"] = this.transcriptMeta;
        data["transcriptText"] = this.transcriptText;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranscriptInfo {
    transcriptMeta?: string | undefined;
    transcriptText?: string | undefined;
    participants?: ParticipantInfo[] | undefined;
}

export class TranscriptMetaJson implements ITranscriptMetaJson {
    version?: string | undefined;

    [key: string]: any;

    constructor(data?: ITranscriptMetaJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.version = _data["Version"];
        }
    }

    static fromJS(data: any): TranscriptMetaJson {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptMetaJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Version"] = this.version;
        return data;
    }
}

export interface ITranscriptMetaJson {
    version?: string | undefined;

    [key: string]: any;
}

export class TranscriptRowForML implements ITranscriptRowForML {
    startTicks?: number;
    speakerId?: string;
    text?: string | undefined;
    durationTicks?: number;

    constructor(data?: ITranscriptRowForML) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTicks = _data["startTicks"];
            this.speakerId = _data["speakerId"];
            this.text = _data["text"];
            this.durationTicks = _data["durationTicks"];
        }
    }

    static fromJS(data: any): TranscriptRowForML {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptRowForML();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTicks"] = this.startTicks;
        data["speakerId"] = this.speakerId;
        data["text"] = this.text;
        data["durationTicks"] = this.durationTicks;
        return data;
    }
}

export interface ITranscriptRowForML {
    startTicks?: number;
    speakerId?: string;
    text?: string | undefined;
    durationTicks?: number;
}

export class TranscriptTextJson implements ITranscriptTextJson {
    speakers?: SpeakerTranscriptJson[] | undefined;
    created_date?: Date | undefined;

    [key: string]: any;

    constructor(data?: ITranscriptTextJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(SpeakerTranscriptJson.fromJS(item));
            }
            this.created_date = _data["created_date"] ? new Date(_data["created_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TranscriptTextJson {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptTextJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        data["created_date"] = this.created_date ? this.created_date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITranscriptTextJson {
    speakers?: SpeakerTranscriptJson[] | undefined;
    created_date?: Date | undefined;

    [key: string]: any;
}

export class UpdateMeetingInfoRequest implements IUpdateMeetingInfoRequest {
    subject?: string | undefined;
    location?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    updatedParticipants?: ParticipantRenameInfo[] | undefined;

    constructor(data?: IUpdateMeetingInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.location = _data["location"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["updatedParticipants"])) {
                this.updatedParticipants = [] as any;
                for (let item of _data["updatedParticipants"])
                    this.updatedParticipants!.push(ParticipantRenameInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMeetingInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["location"] = this.location;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.updatedParticipants)) {
            data["updatedParticipants"] = [];
            for (let item of this.updatedParticipants)
                data["updatedParticipants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMeetingInfoRequest {
    subject?: string | undefined;
    location?: string | undefined;
    startUtc?: Date;
    endUtc?: Date;
    updatedParticipants?: ParticipantRenameInfo[] | undefined;
}

export class UpdateMeetingInfoResponse implements IUpdateMeetingInfoResponse {
    subject?: string | undefined;
    participants?: ParticipantInfo[] | undefined;
    locations?: LocationInfo[] | undefined;
    startUtc?: Date;
    endUtc?: Date;
    isOwn?: boolean;
    transcriptMeta?: string | undefined;
    transcriptText?: string | undefined;

    constructor(data?: IUpdateMeetingInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantInfo.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationInfo.fromJS(item));
            }
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
            this.isOwn = _data["isOwn"];
            this.transcriptMeta = _data["transcriptMeta"];
            this.transcriptText = _data["transcriptText"];
        }
    }

    static fromJS(data: any): UpdateMeetingInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        data["isOwn"] = this.isOwn;
        data["transcriptMeta"] = this.transcriptMeta;
        data["transcriptText"] = this.transcriptText;
        return data;
    }
}

export interface IUpdateMeetingInfoResponse {
    subject?: string | undefined;
    participants?: ParticipantInfo[] | undefined;
    locations?: LocationInfo[] | undefined;
    startUtc?: Date;
    endUtc?: Date;
    isOwn?: boolean;
    transcriptMeta?: string | undefined;
    transcriptText?: string | undefined;
}

export class UpdateSummaryRequest implements IUpdateSummaryRequest {
    summaryBlocks?: SummaryBlock[] | undefined;
    meta?: any | undefined;

    constructor(data?: IUpdateSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["summaryBlocks"])) {
                this.summaryBlocks = [] as any;
                for (let item of _data["summaryBlocks"])
                    this.summaryBlocks!.push(SummaryBlock.fromJS(item));
            }
            this.meta = _data["meta"];
        }
    }

    static fromJS(data: any): UpdateSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.summaryBlocks)) {
            data["summaryBlocks"] = [];
            for (let item of this.summaryBlocks)
                data["summaryBlocks"].push(item.toJSON());
        }
        data["meta"] = this.meta;
        return data;
    }
}

export interface IUpdateSummaryRequest {
    summaryBlocks?: SummaryBlock[] | undefined;
    meta?: any | undefined;
}

export class UploadRecordingRequest implements IUploadRecordingRequest {
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    participants?: AddParticipantRequest[] | undefined;

    constructor(data?: IUploadRecordingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordingStartUtc = _data["recordingStartUtc"] ? new Date(_data["recordingStartUtc"].toString()) : <any>undefined;
            this.recordingEndUtc = _data["recordingEndUtc"] ? new Date(_data["recordingEndUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(AddParticipantRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadRecordingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRecordingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordingStartUtc"] = this.recordingStartUtc ? this.recordingStartUtc.toISOString() : <any>undefined;
        data["recordingEndUtc"] = this.recordingEndUtc ? this.recordingEndUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadRecordingRequest {
    recordingStartUtc?: Date;
    recordingEndUtc?: Date;
    participants?: AddParticipantRequest[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class SummaryBlockExtData {
    items: SummaryBlockItem[] = [];
    agendaItems: {[id: string]: SummaryBlockItem[]} = {};

    getAllItems(): SummaryBlockItem[] {
        let result = [];
        Object.keys(this.agendaItems).forEach(agendaItemId => {
            const agendaItems = this.agendaItems[agendaItemId];
            agendaItems.forEach(item => item.agendaItemId = agendaItemId);
            result = result.concat(agendaItems);
        })

        result = result.concat(this.items);

        return result;
    }
}